import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`pagination__item ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <nav class="pagination__wrapper">
            <ul class="pagination">
                {prev && (
                    <li class="pagination__page">
                        <PageLink {...pageLinkProps(prev)} className="ns-previous" ariaLabel="Previous page">
                            <Icon name="arrow" className="ns-page-prev-icon" />
                        </PageLink>
                    </li>
                )}

                {first && (
                    <>
                        <li class="pagination__page">
                            <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                                {first.page}
                            </PageLink>
                        </li>
                        <li class="pagination__page"><span class="">...</span></li>
                    </>
                )}

                {pages.map(page => (
                    <li key={page.page} class="pagination__page pagination__item">
                        <PageLink className={`${page.current ? "pagination__item--active" : "pagination__item--link"}`} ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>{page.page}</PageLink>
                    </li>
                ))}

                {last && (
                    <>
                        <li class="pagination__page"><span class="ns-py-2 ns-px-4">...</span></li>
                        <li class="pagination__page">
                            <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
                        </li>
                    </>
                )}

                {next && (
                    <li class="pagination__page">
                        <PageLink {...pageLinkProps(next)} className="ns-next" ariaLabel="Next page">
                            <Icon name="arrow" className="ns-page-next-icon" />
                        </PageLink>
                    </li>
                )}
            </ul>
        </nav>
    )
}
